export default __webpack_public_path__ + "static/media/NotoSans-Medium.0ac2002e.woff2";